import React from 'react';
import { VerticalNavigationItem } from '@here/hds-vertical-navigation';
// eslint-disable-next-line no-new
new VerticalNavigationItem();
const HDSVerticalNavigationItem = React.forwardRef((props, ref) => {
    const { selected, avatarUrl, avatarName, iconStyle, className, iconCategory, children, ...rest } = props;
    return (React.createElement("hds-vertical-navigation-item", { ref: ref, ...(className && { class: className }), ...(selected && { selected }), ...(avatarUrl && { 'avatar-url': avatarUrl }), ...(avatarName && { 'avatar-name': avatarName }), ...(iconCategory && { 'icon-category': iconCategory }), ...(iconStyle && { 'icon-style': iconStyle }), ...rest }, children));
});
HDSVerticalNavigationItem.defaultProps = {
    avatarUrl: '',
    avatarName: '',
    selected: false,
};
export default HDSVerticalNavigationItem;
//# sourceMappingURL=HDSVerticalNavigationItem.js.map